import { gql } from '@apollo/client';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { USER_SETTINGS_CHANGE_LOCAL } from 'constants/index';
import persistUserSnapshot from './persistUserSnapshot';

export const SAVE_USER_SETTINGS = gql`
  mutation UpdateUserSettings2($settings: SettingsInput) {
    UpdateUserSettings2(settings: $settings) {
      id
      search_filters_visible
      show_alacarte_content
      ingredient_shop_vendor
      collection_picker_sort_order
      collection_view_sort_order
      show_kcal_on_tiles
      nutrition_diet_limit
      nutrition_diet_prefer
      culinary_topics
      culinary_regions
      onboarding_preferences_status
      onboarding_preferences_asked_at
      onboarding_panels
    }
  }
`;

export default function saveUserSettings(fields) {
  return async (dispatch, getState, { client }) => {
    const settings = getState().user.settings || {};
    // Keys absent from settings must roll back to undefined, not vanish from the
    // payload: USER_SETTINGS_CHANGE_LOCAL merges, so a missing key keeps the
    // optimistic value.
    const rollback = Object.keys(fields).reduce(
      (previous, key) => ({ ...previous, [key]: settings[key] }),
      {},
    );

    const apply = payload => {
      dispatch({ type: USER_SETTINGS_CHANGE_LOCAL, payload });
      persistUserSnapshot(getState().user);
    };

    // Drop keys a newer save has already moved on: this one settles late and its
    // value - confirmed or rolled back - is stale by then.
    const notSuperseded = payload => {
      const live = getState().user.settings || {};
      return pickBy(payload, (value, key) => isEqual(live[key], fields[key]));
    };

    apply(fields);

    try {
      const { data } = await client.mutate({
        mutation: SAVE_USER_SETTINGS,
        variables: { settings: fields },
      });
      if (data && data.UpdateUserSettings2) {
        // The mutation answers with the whole settings row, so keep only what
        // this call owns or it reverts fields another save just changed.
        apply(notSuperseded(pick(data.UpdateUserSettings2, Object.keys(fields))));
      }
    } catch (error) {
      console.error('Failed to save user settings', error);
      apply(notSuperseded(rollback));
    }
  };
}
